import React from 'react';
import { Heatmap } from 'react-hour-heatmap';
import data from "../../../../content/data.json";
export default {
  React,
  Heatmap,
  data
};